import { render } from "./CartReviewOrder.vue?vue&type=template&id=889ce530"
import script from "./CartReviewOrder.vue?vue&type=script&lang=js"
export * from "./CartReviewOrder.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__